import { DocumentDetailModel } from '../../models/documentDetail'

export const getPaymentDetailValue = (
  paymentDetail: DocumentDetailModel[],
  checkboxName: string,
  dataKey: string
): any => {
  const payAmount = paymentDetail.filter(data => {
    return data.paymentMethod.name === checkboxName
  })[0]

  switch (dataKey) {
    case 'cheque_Bank':
      return payAmount.cheque_Bank
    case 'cheque_BankCode':
      return payAmount.cheque_BankCode
    case 'cheque_Branch':
      return payAmount.cheque_Branch
    case 'cheque_Number':
      return payAmount.cheque_Number
    case 'cheque_Date':
      return payAmount.cheque_Date
    case 'creditCard_HolderName':
      return payAmount.creditCard_HolderName
    case 'creditCard_HolderRelationship':
      return payAmount.creditCard_HolderRelationship
    case 'creditCard_Type':
      return payAmount.creditCard_Type
    case 'creditCard_Number':
      return payAmount.creditCard_Number
    case 'creditCard_ExpDate':
      return payAmount.creditCard_ExpDate
    case 'other_Pay':
      return payAmount.other_Pay
    case 'payInToBank':
      return payAmount.payInToBank
    case 'payInDate':
      return payAmount.payInDate
    case 'bankName':
      return payAmount.bankName
    case 'bankCode':
      return payAmount.bankCode
    case 'accountNo':
      return payAmount.accountNo
    default:
      return ''
  }
}

export const getPaymentDetailValueByObj = (payAmount: any, dataKey: string): any => {
  switch (dataKey) {
    case 'paymentAmount':
      return payAmount.paymentAmount
    case 'cheque_Bank':
      return payAmount.cheque_Bank
    case 'cheque_BankCode':
      return payAmount.cheque_BankCode
    case 'cheque_Branch':
      return payAmount.cheque_Branch
    case 'cheque_Number':
      return payAmount.cheque_Number
    case 'cheque_Date':
      return payAmount.cheque_Date
    case 'creditCard_HolderName':
      return payAmount.creditCard_HolderName
    case 'creditCard_HolderRelationship':
      return payAmount.creditCard_HolderRelationship
    case 'creditCard_Type':
      return payAmount.creditCard_Type
    case 'creditCard_Number':
      return payAmount.creditCard_Number
    case 'creditCard_ExpDate':
      return payAmount.creditCard_ExpDate
    case 'other_Pay':
      return payAmount.other_Pay
    case 'payInToBank':
      return payAmount.payInToBank
    case 'payInDate':
      return payAmount.payInDate
    case 'bankName':
      return payAmount.bankName
    case 'bankCode':
      return payAmount.bankCode
    case 'accountNo':
      return payAmount.accountNo
    case 'accountNo':
      return payAmount.accountNo
    case 'remarkMoneyType':
      return payAmount.remarkMoneyType
    default:
      return ''
  }
}

export const getPaymentDetailAmount = (
  paymentDetail: DocumentDetailModel[],
  checkboxName: string
) => {
  const payAmount = paymentDetail.filter(data => {
    return data.paymentMethod.name === checkboxName
  })[0]

  return payAmount.paymentAmount > 0 ? payAmount.paymentAmount : ''
}

export const getPaymentTotalAmount = (
  paymentDetail: DocumentDetailModel[],
  checkboxName: string
) => {
  const payAmount = paymentDetail.filter(data => {
    return data.paymentMethod.name === checkboxName
  })[0]

  if (typeof payAmount.paymentTotalAmount === 'number' && payAmount.paymentTotalAmount > 0) {
    return payAmount.paymentTotalAmount
  }

  return ''
}

export const getPaymentDetailObj = (paymentDetail: DocumentDetailModel, addOn: any) => {
  const mergedObj = {
    ...paymentDetail,
    ...addOn
  }

  return mergedObj
}
